import { render, staticRenderFns } from "./UpdatePaymentModal.vue?vue&type=template&id=22c24c8d&scoped=true&"
import script from "./UpdatePaymentModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePaymentModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePaymentModal.vue?vue&type=style&index=0&id=22c24c8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c24c8d",
  null
  
)

export default component.exports